import { render, staticRenderFns } from "./ModalRegraAprovacao.vue?vue&type=template&id=f62c40b8"
import script from "./ModalRegraAprovacao.vue?vue&type=script&lang=js"
export * from "./ModalRegraAprovacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f62c40b8')) {
      api.createRecord('f62c40b8', component.options)
    } else {
      api.reload('f62c40b8', component.options)
    }
    module.hot.accept("./ModalRegraAprovacao.vue?vue&type=template&id=f62c40b8", function () {
      api.rerender('f62c40b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalRegraAprovacao.vue"
export default component.exports